exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir=ltr] ._1pI6K5lpSoTwpIYif_u8IJ{margin:0 0 5px 12px}html[dir=rtl] ._1pI6K5lpSoTwpIYif_u8IJ{margin:0 12px 5px 0}._1GpIT8XnHs_gdLNtCCMH_x{color:\"[theme:neutralPrimary, default:#323130]\"}html[dir=ltr] ._1GpIT8XnHs_gdLNtCCMH_x{margin-right:6px}html[dir=rtl] ._1GpIT8XnHs_gdLNtCCMH_x{margin-left:6px}", ""]);
// Exports
exports.locals = {
	"removeDueDate": "_1pI6K5lpSoTwpIYif_u8IJ",
	"removeDueDateIcon": "_1GpIT8XnHs_gdLNtCCMH_x"
};